import { AmountUsd } from '@ui/components/Amount/AmountUsd';
import { usePriceLive } from '@ui/hooks/price/usePriceLive';
import { useTokenDisplayDecimals } from '@ui/hooks/useTokenDisplayDecimals';
import { Text } from '@ui/lib/park/ui/text';
import { useTranslation } from 'next-i18next';
import { VStack } from 'styled-system/jsx';

import { GenericTradeParams } from '../../../types';
import { headLabelStyle, headValueStyle } from '../styles';

export const MarketPrice = ({ genericTradeParams }: GenericTradeParams) => {
  const { t } = useTranslation();
  const pairPrice = usePriceLive(genericTradeParams.pair.baseSymbol);
  const priceDisplayDecimals = useTokenDisplayDecimals(
    genericTradeParams?.pair.baseSymbol,
    genericTradeParams?.pair.priceDisplayDecimals,
  );

  return (
    <VStack gap={1} justifyContent="center" alignItems="flex-start">
      <Text css={headLabelStyle}>{t('common.Market')}</Text>
      <AmountUsd
        css={headValueStyle}
        value={pairPrice}
        opts={{
          displayDecimals: priceDisplayDecimals,
        }}
        data-cy="MarketPrice"
        data-cy-value={pairPrice}
      />
    </VStack>
  );
};
